import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutHandlingRequirementsCompareItem extends Layout {
	sourceEdiCompareItem: DataSource;
	tableCompareItems: Table;
}
